// Import the necessary modules and assets
import * as bootstrap from 'bootstrap';
import newPassword from "./helpers/new-password.js";
import { bindRecaptchaFormSubmission } from "./helpers/recaptcha.js";

/**
 * Auth class for authentication related JS functionality.
 */
class Auth {
    constructor() {
        this._init();
    }

    /**
     * Initialize the Auth class
     */
    _init() {
        console.log('[Auth] Initializing...');

        this._initPasswordToggle();
        this._bindRecaptchaFormSubmission();
        this._initDVSSelector();
        this._initContactFormValidation();
        newPassword(document.getElementById('container-auth-force-new-password'));

        console.log('[Auth] Initialized!');
    }

    /**
     * Initialize the password toggle functionality.
     * Adds click event listeners to elements with the class 'toggle-password'.
     * Toggles the input type between 'text' and 'password' and updates the icon accordingly.
     *
     * @protected
     */
    _initPasswordToggle() {
        let togglePassword = document.querySelectorAll('.toggle-password');

        togglePassword.forEach(function(toggle) {
            toggle.addEventListener('click', function() {
                let inputPassword = this.parentElement.querySelector('input');

                // Toggle the input type between 'text' and 'password'
                inputPassword.type = inputPassword.type === 'text' ? 'password' : 'text';

                // If the icon element does not exist, return
                if(!this.querySelector('.icon')) {
                    return;
                }

                // Update the icon to reflect the current state
                this.querySelector('.icon').classList.toggle('fa-eye');
                this.querySelector('.icon').classList.toggle('fa-eye-slash');
            });
        });
    }

    /**
     * Bind form submission to execute reCAPTCHA.
     * Delegates to the shared recaptcha helper.
     *
     * @see resources/js/helpers/recaptcha.js
     * @protected
     */
    _bindRecaptchaFormSubmission() {
        bindRecaptchaFormSubmission();
    }

    /**
     * Initialize the contact form validation.
     * Disables the submit button until all required fields are filled in.
     *
     * @protected
     */
    _initContactFormValidation() {
        const modal = document.getElementById('modal-contact');

        if (!modal) {
            return;
        }

        const form = modal.querySelector('form');

        if (!form) {
            return;
        }

        const submitButton = form.querySelector('button[type="submit"]');

        if (!submitButton) {
            return;
        }

        const requiredFields = form.querySelectorAll('input[name="name"], input[name="email"], input[name="subject"], textarea[name="message"]');

        const checkFields = function () {
            let allFilled = true;

            requiredFields.forEach(function (field) {
                if (!field.value.trim()) {
                    allFilled = false;
                }
            });

            submitButton.disabled = !allFilled;
        };

        // Initial check
        checkFields();

        // Listen for input events
        requiredFields.forEach(function (field) {
            field.addEventListener('input', checkFields);
        });
    }

    /**
     * Initialize the DVS selector functionality.
     * Adds a click event listener to the element with the id 'select-dvs'.
     * Submits the inner form when the element is clicked.
     *
     * @protected
     */
    _initDVSSelector() {
        const dvsSelector = document.getElementById('dvs-selector');

        if(!dvsSelector) {
            return;
        }

        dvsSelector.querySelectorAll('.select-dvs').forEach(function(selectDvs) {
            selectDvs.addEventListener('click', function(e) {
                // Get the corresponding form element within the select-dvs element and submit it
                const form = this.querySelector('form');

                if (form) {
                    form.submit();
                } else {
                    console.error("[Auth] No 'Form' element found within the selected 'select-dvs' element.");
                }
            });
        });
    }
}

window.addEventListener('load', () => {
    window.auth = new Auth();
});
